import SuggestedActionsEmptyState from './SuggestedActionsEmptyState.component';

export default SuggestedActionsEmptyState;